import { render } from "./CustomerHeadCreate.vue?vue&type=template&id=3b572e3a"
import script from "./CustomerHeadCreate.vue?vue&type=script&lang=js"
export * from "./CustomerHeadCreate.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__